import { apiClient } from "./client";

export type UserSessionOut = {
  id: string;
  created_at: string;
  last_used_at: string | null;
  expires_at: string;
  ip_address: string | null;
  user_agent: string | null;
  is_current: boolean;
};

export async function listMySessions(): Promise<UserSessionOut[]> {
  const { data } = await apiClient.get<UserSessionOut[]>("/api/v1/me/sessions");
  return data;
}

export async function revokeSession(id: string): Promise<void> {
  await apiClient.post(`/api/v1/me/sessions/${id}/revoke`);
}

export async function revokeOtherSessions(): Promise<{ revoked: number }> {
  const { data } = await apiClient.post<{ revoked: number }>(
    "/api/v1/me/sessions/revoke-others",
  );
  return data;
}
